import type { SvgComponent } from '@/types/SvgComponent';

export const PlayOutlineIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M4.5 3.73876V20.2613C4.50245 20.3931 4.53962 20.522 4.60776 20.6349C4.6759 20.7478 4.7726 20.8407 4.88812 20.9043C5.00364 20.9679 5.13388 20.9999 5.26572 20.9972C5.39756 20.9944 5.52634 20.9569 5.63906 20.8884L19.1466 12.6272C19.2545 12.5619 19.3437 12.4699 19.4056 12.36C19.4675 12.2501 19.5001 12.1261 19.5001 12C19.5001 11.8739 19.4675 11.7499 19.4056 11.64C19.3437 11.5302 19.2545 11.4381 19.1466 11.3728L5.63906 3.11157C5.52634 3.04314 5.39756 3.00564 5.26572 3.00285C5.13388 3.00007 5.00364 3.03209 4.88812 3.0957C4.7726 3.1593 4.6759 3.25224 4.60776 3.36514C4.53962 3.47804 4.50245 3.60691 4.5 3.73876Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
